module.exports = __webpack_public_path__ + "img/template02.807bb308.jpg";